import { Component } from '@angular/core';

@Component({
  selector: 'app-touch-guide',
  templateUrl: './touch-guide.component.html',
  styleUrls: ['./touch-guide.component.scss'],
})
export class TouchGuideComponent {}
